// Cube AirTent theme — small global behaviors.
document.addEventListener('click', function (e) {
  var mobileNav = document.getElementById('mobile-nav');
  if (mobileNav && mobileNav.classList.contains('is-open')) {
    if (!mobileNav.contains(e.target) && !e.target.closest('.nav-toggle')) {
      mobileNav.classList.remove('is-open');
    }
  }
});
